import React from 'react';
import { TCN, TCN_COLOR_MAP } from '../../tcn/ui-kit/tokens';

/**
 * Briefing — Priority Card (mockup module67-support.jsx:24-39)
 *
 * Numbered priority card on the morning briefing splash. Mockup pattern:
 *  - padding 16, surface1, border `${color}33`, radius 14, marginBottom 10
 *  - 28x28 round bubble with the rank number in #000 / 800 / 13px
 *  - title 14/700/lineHeight 1.3
 *  - sub 12/textDim/marginTop 4
 *
 * Props:
 *   - rank: 1 | 2 | 3
 *   - title: short bold line
 *   - body: 1-2 sentence description
 *   - accent: 'amber' | 'red' | 'magenta' | 'cyan' | 'green' (mockup: 1=amber, 2=red, 3=magenta)
 *   - meta: optional small mono-font line (e.g. usernames)
 */
const PriorityCard = ({ rank, title, body, accent = 'cyan', meta }) => {
  const c = TCN_COLOR_MAP[accent] ?? accent;

  return (
    <div
      style={{
        padding: 16,
        background: TCN.surface1,
        border: `1px solid ${c}33`,
        borderRadius: 14,
        display: 'flex',
        alignItems: 'flex-start',
        gap: 12,
      }}
    >
      <div
        style={{
          width: 28,
          height: 28,
          borderRadius: 99,
          background: c,
          color: '#000',
          fontWeight: 800,
          fontSize: 13,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
          fontFamily: TCN.fontSans,
        }}
      >
        {rank}
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div
          style={{
            fontSize: 14,
            fontWeight: 700,
            color: TCN.text,
            lineHeight: 1.3,
          }}
        >
          {title}
        </div>
        {body && (
          <div
            style={{
              fontSize: 12,
              color: TCN.textDim,
              marginTop: 4,
              lineHeight: 1.4,
            }}
          >
            {body}
          </div>
        )}
        {meta && (
          <div
            style={{
              fontSize: 11,
              color: TCN.textMute,
              marginTop: 6,
              fontFamily: TCN.fontMono,
              fontVariantNumeric: 'tabular-nums',
            }}
          >
            {meta}
          </div>
        )}
      </div>
    </div>
  );
};

export default PriorityCard;
